module.exports = __webpack_public_path__ + "media/images/icon__warning@3x-1fa54720a01a6e9142e634935dd52b40.png";